<template>
    <div class="homes">
        <div style="display: flex;justify-content: space-between;width: 60vw;align-items: center;">
            <div style="text-align: left;">
                <div style="font-size: 28px;font-weight: bold;color: rgba(24,24,24,1);">{{ zh_en=='zh'?'产业集群':'Industrial Clusters' }}</div>
                <!-- <div style="font-size: 22px; color: #181818;">基于三百年吴门医药传承让当代大众活出真健康</div> -->
            </div>


            <div style="text-align: right;">
                <LookMore :linkUrl="'/company'" />
            </div>
        </div>



        <div style="padding: 40px 0;width: 60vw;position: relative;">

            <div class="defautlBox" v-for="(item, index) in brand_list" @click="changeIndex(index)" :key="index"
                :class='activityIndex == index ? "activity" : ""' style="display: flex;align-items: center;">
                <div> <img :src="staticUrl + item.image" style="height: 150px;width: 240px;margin-right: 20px;" alt="">
                </div>
                <div style="flex: 1;height: 100%;text-align: left;">
                    <div style="color: #8A2E26;">{{ item.title }}</div>
                    <div>{{ item.abstract }}</div>
                </div>
            </div>


            <div style="position: absolute;bottom: 10px; left: 0;right: 0;margin: auto;">
                <el-pagination background layout="prev, pager, next" :total="companyTotal" :page-size="3" @current-change="currentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import LookMore from '@/components/home/LookMore.vue'

// @ is an alias to /src
export default {
    props: {
        brand_list: {
            default: []
        },
        companyTotal: {
            default: 0
        }
    },
    data() {
        return {
            activityIndex: 0,
            staticUrl: this.STATICURL,

        }
    },
    components: {
        LookMore
    },
    methods: {
        changeIndex(e) {
            this.activityIndex = e
        },
        currentChange(e){
            console.log('页码改变',e);
            this.$emit('currentChange',e)
        }
    }

}
</script>


<style lang="less" scoped>
.homes {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-image: url(../../static/images/home1Back.png);
    background-size: 100% 100%;
}

.defautlBox {
    width: 100%;
    height: 168px;
    background-color: transparent;
    margin-bottom: 20px;
}

.activity {
    width: 100%;
    height: 168px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.14);
}
</style>